import { Component, inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { PAGE_CONSTANTS } from '../../../shared/constants/page.constants';
import { FileTriageData } from '../../../interfaces/fileTriage.interface';
import { CommonModule } from '@angular/common';
import { ListService } from '../../../shared/services/list.service';
import { PayrollNatPayDetailComponent } from "../payroll-nat-pay-details/payroll-nat-pay-detail.component";
import { DialogConfig, DialogService } from '../../../shared/services/dialog.service';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { NzUploadModule, NzUploadXHRArgs } from 'ng-zorro-antd/upload';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzMessageService } from 'ng-zorro-antd/message';
import { SharedService } from '../../../shared/services/shared.service';
import { TableRowAction, TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../shared/interfaces/actions';
import { UserService } from '../../../services/user.service';

@Component({
  selector: 'ppl-payroll-nat-pay-list',
  standalone: true,
  imports: [
    ListTableComponent,
    CommonModule,
    PayrollNatPayDetailComponent,
    NzUploadModule,
  ],
  templateUrl: './payroll-nat-pay-list.component.html',
  styleUrl: './payroll-nat-pay-list.component.css',
})
export class PayrollNatPayListComponent implements OnInit {
  @ViewChild('natpayFilesDetails') natpayFilesDetails!: TemplateRef<any>;
  @ViewChild(ListTableComponent) listTableComponent!: ListTableComponent;

  private dialogSvc = inject(DialogService);

  pageId: string = PAGE_CONSTANTS.PAYLIST_DATA_GRID_PAGE;
  programName!: string;
  columnsToBeHidden: any = [];
  sharedDataKey: string = STATIC_DATA.SHARED_FILE_PAYLIST_DATA;
  actionsToBeHidden: any = [];
  isPageRestrictionLoaded = false;
  pdfFile?: any;
  pdfConfig: any;
  checkedRows: FileTriageData[] = [];
  dialogId: any;
  selectedRow: any;
  uploadForm!: FormGroup;
  actionButtons: TableRowActionsModel = new TableRowActions({ download: true });

  constructor(
    public listService: ListService,
    private fb: FormBuilder,
    private msg: NzMessageService,
    private sharedService: SharedService,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.uploadForm = this.fb.group({
      document_type: [''],
      other_type: [''],
    });
    const selectedProgram = this.userService.getSelectedProgram();
    this.programName = selectedProgram?.program_code ?? '';
  }

  ngOnDestory() {
  }

  rowClicked(selectedRow: any) {
    this.selectedRow = selectedRow;
    this.openDetailListPopup();
  }

  handleCancel() {
    this.pdfFile = null;
  }

  openDetailListPopup() {
    const dialogConfig: DialogConfig = {
      title: 'Payroll Nat Pay Detail List',
      isOkText: 'Save',
      size: 'xx-large',
      position: 'top',
      showClose: true,
      showButtons: false,
    };

    this.dialogId = this.dialogSvc.openDialog(
      this.natpayFilesDetails,
      dialogConfig,
      () => this.handleCancel(),
      () => this.handleCancel()
    );
  }

  customRequest = (item: NzUploadXHRArgs): any => {
    let inputValue = this.uploadForm.value.document_type;
    const formData = new FormData();
    formData.append('file', item.file as any);
    const allowedExtensions = ['csv'];
    const fileExtension = item.file.name.split('.').pop()?.toLowerCase();
    console.log('fileExtension', fileExtension);
    if (allowedExtensions.includes(fileExtension || '')) {
      const requestPayload = {
        fileName: item.file.name.split('.').pop(),
        fileType: inputValue,
        programCode: this.programName,
      };

      formData.append(
        'json',
        new Blob([JSON.stringify(requestPayload)], { type: 'application/json' })
      );

      this.sharedService.uploadNATFile(formData).subscribe({
        next: (response: any) => {
          if (item.onSuccess) {
            item.onSuccess(response, item.file, null);
            this.listTableComponent.leadUpdated(true);
          }
        },
        error: (error: any) => {
          if (item.onError) {
            item.onError(error, item.file);
          }
        },
      });
    } else {
      this.msg.error(
        `Invalid file type selected. Please select a valid file.`
      );
    }
  };

  onAction(event: any) {
    if ((event.action === TableRowAction.Download)) {
      this.handleDownload(event.data.natpayfileid, event.data.filename);
    }
  }

  handleDownload(fileId: string, selectedFileName: string) {
    this.sharedService.downloadNatPayFile(
      this.programName,
      fileId,
      selectedFileName
    );
  }
}